import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=2ba745d6&scoped=true&"
import script from "./suspension.vue?vue&type=script&lang=js&"
export * from "./suspension.vue?vue&type=script&lang=js&"
import style0 from "./suspension.vue?vue&type=style&index=0&lang=less&"
import style1 from "./suspension.vue?vue&type=style&index=1&id=2ba745d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba745d6",
  null
  
)

export default component.exports